"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _rootShouldForwardProp = _interopRequireDefault(require("../styles/rootShouldForwardProp"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _Drawer = require("../Drawer/Drawer");
var _jsxRuntime = require("react/jsx-runtime");
var SwipeAreaRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiSwipeArea',
    shouldForwardProp: _rootShouldForwardProp.default
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: theme.zIndex.drawer - 1,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    right: 'auto'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    bottom: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    bottom: 0,
                    right: 0
                }
            }
        ]
    };
}));
/**
 * @ignore - internal component.
 */ var SwipeArea = /*#__PURE__*/ React.forwardRef(function SwipeArea(props, ref) {
    var anchor = props.anchor, _props_classes = props.classes, classes = _props_classes === void 0 ? {} : _props_classes, className = props.className, width = props.width, style = props.style, other = _object_without_properties(props, [
        "anchor",
        "classes",
        "className",
        "width",
        "style"
    ]);
    var ownerState = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwipeAreaRoot, _object_spread({
        className: (0, _clsx.default)('PrivateSwipeArea-root', classes.root, classes["anchor".concat((0, _capitalize.default)(anchor))], className),
        ref: ref,
        style: _object_spread(_define_property({}, (0, _Drawer.isHorizontal)(anchor) ? 'width' : 'height', width), style),
        ownerState: ownerState
    }, other));
});
process.env.NODE_ENV !== "production" ? SwipeArea.propTypes = {
    /**
   * Side on which to attach the discovery area.
   */ anchor: _propTypes.default.oneOf([
        'left',
        'top',
        'right',
        'bottom'
    ]).isRequired,
    /**
   * @ignore
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * @ignore
   */ style: _propTypes.default.object,
    /**
   * The width of the left most (or right most) area in `px` where the
   * drawer can be swiped open from.
   */ width: _propTypes.default.number.isRequired
} : void 0;
var _default = exports.default = SwipeArea;
